import icImportant from '@/assets/ic_important.svg';

export const PinsDiscountLegend = () => {
  return (
    <div className="flex justify-center bg-gdt-blue-xl2 bg-opacity-30 h-8 lg:h-10 items-center rounded-md mb-6 -mt-4">
      <figure>
        <img src={icImportant} />
      </figure>
      <p className="text-gdt-blue-dark text-xs lg:text-sm font-semibold items-center ms-2">
        Se te descontará 1 pin de tu cuenta.
      </p>
    </div>
  );
};
